import { memo } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import UI Components
import { Icon } from '@geneui/components';
// Import Hooks
import { usePartnerDateFormats } from 'hooks/UsePartnerDateFormats';
// Import Constants
import { SegmentTypesLabels, l, SegmentTypeIconClasses } from 'constants/common';
// Import Helpers
import { formatDateTime } from './helpers';

const SegmentWidget = ({ data }) => {
    const { t } = useTranslation();

    const { partnerDateTimeFormat } = usePartnerDateFormats();

    return (
        <div className="campaign-tabs-inner">
            <div>
                <div className="campaign-tab-icon segment-icon">
                    <Icon type="bc-icon-segment" />
                </div>
                <div className="campaign-tab-content-wrapper">
                    {isNil(data) ? (
                        <div>
                            <p className="campaign-tab-heading">{t(l.Segment)}</p>
                            <p className="campaign-tab-desc">{t(l.SegmentDescription)}</p>
                        </div>
                    ) : (
                        <div>
                            <div className="campaign-tab-heading-group">
                                <p className="campaign-tab-title">{t(l.Segment)}</p>
                                <p className="campaign-tab-subtitle">{data?.title}</p>
                            </div>
                            <div className="campaign-tab-content">
                                <div className="campaign-tab-content-part">
                                    <div className="campaign-tab-content-type">
                                        <span>{t(l.Type)}:</span>
                                        <>
                                            <Icon type={SegmentTypeIconClasses[data.type]} />
                                            <p>{t(SegmentTypesLabels[data.type])}</p>
                                        </>
                                    </div>
                                    <div className="campaign-tab-user-info">
                                        <span>{t(l.User)}:</span>
                                        <p>{data.user}</p>
                                    </div>
                                </div>
                                <div className="campaign-tab-content-part">
                                    <div className="campaign-tab-date">
                                        <span>{t(l.CreatedDate)}:</span>
                                        <p>{formatDateTime(data.createdDate, partnerDateTimeFormat)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

SegmentWidget.propTypes = {
    data: PropTypes.object,
};

SegmentWidget.defaultProps = {
    data: null,
};

export default memo(SegmentWidget);
